import getApiClient from '@/plugins/api'
import router from '@/router'
import updateNavigationRoutes from '@/containers/_nav'

export default {
  name: 'Modal',
  data() {
    return {
      modals: [],
      currentIndex: 0,
      show: false,
    }
  },
  computed: {
    lockModal() {
      return this.modals.find(modal => this.isExpiredPersistentDate(modal.persistentWithoutPagarmeIdDate)) || null
    },
    isLocked() {
      return !!this.lockModal
    },
    currentModal() {
      return this.modals[this.currentIndex] || null
    },
    visible() {
      return this.show
    },
  },
  methods: {
    fetchModals() {
      const self = this,
        api = getApiClient(self.$store)

      api.get('modals/fetch')
        .then(response => {
          self.modals = Array.isArray(response.data) ? response.data : []
          self.currentIndex = 0
          self.show = self.modals.length > 0

          self.applyLockdown()
        })
        .catch(error => {
          console.log(error)
        })
    },

    isExpiredPersistentDate(persistentDate) {
      if (!persistentDate || !persistentDate.date) {
        return false
      }

      const date = new Date(persistentDate.date.replace(' ', 'T'))

      if (isNaN(date.getTime())) {
        return false
      }

      return date.getTime() < Date.now()
    },

    applyLockdown() {
      this.$store.commit('setModalLockdown', this.isLocked)
      updateNavigationRoutes()

      if (this.isLocked) {
        this.show = true

        if (!this.$route.path.startsWith('/profile')) {
          router.push('/profile')
        }
      }
    },

    handleAction(action) {
      if (action.type === 'link' && action.link) {
        window.open(action.link, action.target || '_self')
      }

      this.next()
    },

    onShowChange(value) {
      if (!value) {
        this.next()
        return
      }

      this.show = value
    },

    next() {
      if (this.currentIndex < this.modals.length - 1) {
        this.currentIndex++
      } else {
        this.show = false
      }
    },
  },
  mounted() {
    this.fetchModals()
  },
}
